exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".app5-page {\n\tdisplay: none;\n}\n\n.app5-page-active {\n\tdisplay: block;\n}\n\nlabel.ng-invalid {\n    color: #E20077;\n    font-weight: bold;\n}\ninput.ng-invalid, select.ng-invalid, textarea.ng-invalid {\n    border-color: #E20077 !important;\n    box-shadow: 0 0 0 1px #E20077 !important;\n}\ninput.ng-invalid:focus, select.ng-invalid:focus, textarea.ng-invalid:focus {\n    background-color: #FFFFFF !important;\n}\n.ng-cloak {\n\tdisplay: none;\n}\n\n.test-pass {\n  background-image: url(" + require("./images/debug-renderer/success-bg.png") + ");\n  background-repeat: no-repeat;\n  width: 10px;\n  height: 10px;\n  display: inline-block;\n}\n\n.test-fail {\n  background-image: url(" + require("./images/debug-renderer/error-bg.png") + ");\n  background-repeat: no-repeat;\n  width: 12px;\n  height: 12px;\n  display: inline-block;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/main/ui/core/gfx/app5-main.css
// module id = 72
// module chunks = 0